import { ActionButton, Disclosure, DisclosureTitle, DisclosurePanel, Flex, Link, TextField, View, DateField, DatePicker } from "@adobe/react-spectrum"
import styles from './invoice_detail_section.module.css'
import { useState } from "react"
import JournalDropDown from "./formComponents/JournalDropDown"
import InvoiceCurrencyDropDown from "./formComponents/CurrencyDropDown"
import moment from "moment"
import { parseDate } from "@internationalized/date"
interface IInvoiceDetailSection {
    invoice: any
    onChange: (data: any) => void
    isEdit: any
}
const InvoiceDetailSection: React.FC<IInvoiceDetailSection> = ({ invoice, onChange, isEdit }) => {
    const [showMorefileds, setShowMorefields] = useState<boolean>(false);

    const handleShowMorefields = () => {
        setShowMorefields(!showMorefileds)
    }

    console.log('invoice detail section', invoice)

    return (
        <Flex direction={{ base: 'column', L: 'column' }} UNSAFE_className={styles.main_container} >
            {!showMorefileds ? (
                <Flex direction={'column'}>
                    <Flex justifyContent={'end'}>
                        <Link UNSAFE_className={styles.show_more_button} onPress={handleShowMorefields} isQuiet>Show more</Link>
                    </Flex>
                    <Flex direction={{ base: 'column', L: 'row' }} gap={'size-100'}>
                        <JournalDropDown onChange={(journal) => { onChange({ ...invoice, journal: journal.id }) }} selectedJournal={invoice?.journal} isEdit={isEdit} />
                        <InvoiceCurrencyDropDown selectedCurrency={invoice?.currency} onChange={(currency) => { onChange({ ...invoice, currency: currency?.code }) }} />
                        <TextField
                            label='External Number'
                            width={'100%'}
                            value={invoice?.externalNumber}
                            onChange={(val) => { onChange({ ...invoice, exterNalNumber: val }) }} />
                        <DatePicker
                            label='Issue Date'
                            width={'100%'}
                            value={
                                invoice?.issuedDate
                                    ? parseDate(moment(invoice?.issuedDate).format("YYYY-MM-DD"))
                                    : undefined
                            }
                            onChange={(e) =>
                                onChange({ ...invoice, issuedDate: e?.toString() })
                            } />
                        <DatePicker
                            label='Due Date'
                            width={'100%'}
                            value={
                                invoice?.dueDate
                                    ? parseDate(moment(invoice?.dueDate).format("YYYY-MM-DD"))
                                    : undefined
                            }
                            onChange={(e) =>
                                onChange({ ...invoice, dueDate: e?.toString() })
                            }
                        />
                    </Flex>
                </Flex>
            ) : (
                <Flex direction={'column'} gap={'size-100'}>
                    <Flex justifyContent={'end'}>
                        <Link UNSAFE_className={styles.show_more_button} onPress={handleShowMorefields} isQuiet>Show less</Link>
                    </Flex>
                    <Flex direction={{ base: 'column', L: 'row' }} gap={'size-100'}>
                        <JournalDropDown onChange={(journal) => { onChange({ ...invoice, journal: journal.id }) }} selectedJournal={invoice?.journal} isEdit={isEdit} />
                        <TextField
                            label='Number'
                            value={invoice?.invoiceNumber}
                            onChange={(val) => { onChange({ ...invoice, invoiceNumber: val }) }}
                            width={'100%'} />
                        <DatePicker
                            label='Issue Date'
                            width={'100%'}
                            value={
                                invoice?.issuedDate
                                    ? parseDate(moment(invoice?.issuedDate).format("YYYY-MM-DD"))
                                    : undefined
                            }
                            onChange={(e) =>
                                onChange({ ...invoice, issuedDate: e?.toString() })
                            } />
                        <DatePicker
                            label='Due Date'
                            width={'100%'}
                            value={
                                invoice?.dueDate
                                    ? parseDate(moment(invoice?.dueDate).format("YYYY-MM-DD"))
                                    : undefined
                            }
                            onChange={(e) =>
                                onChange({ ...invoice, dueDate: e?.toString() })
                            }
                        />
                    </Flex>
                    <Flex direction={{ base: 'column', L: 'row' }} gap={'size-100'}>
                        <Flex direction={'row'} width={'100%'} gap={'size-100'}>
                            <TextField
                                label='Rate'
                                width={'30%'}
                                value={invoice?.currencyRate}
                                onChange={(val) => { onChange({ ...invoice, currencyRate: val }) }} />
                            <InvoiceCurrencyDropDown
                                width={'70%'}
                                label={'Currency'}
                                selectedCurrency={invoice?.currency}
                                onChange={(currency) => { onChange({ ...invoice, currency: currency?.code }) }} />
                        </Flex>
                        <TextField
                            label='External Number'
                            width={'100%'}
                            value={invoice?.externalNumber}
                            onChange={(val) => { onChange({ ...invoice, exterNalNumber: val }) }} />
                        <DatePicker
                            label='Taxation Date'
                            width={'100%'}
                            value={
                                invoice?.taxationDate
                                    ? parseDate(moment(invoice?.taxationDate).format("YYYY-MM-DD"))
                                    : undefined
                            }
                            onChange={(e) =>
                                onChange({ ...invoice, taxationDate: e?.toString() })
                            }
                        />
                        <DatePicker
                            label='Transaction Date'
                            width={'100%'}
                            value={
                                invoice?.dateTransaction
                                    ? parseDate(moment(invoice?.dateTransaction).format("YYYY-MM-DD"))
                                    : undefined
                            }
                            onChange={(e) =>
                                onChange({ ...invoice, dateTransaction: e?.toString() })
                            }
                        />
                    </Flex>
                </Flex>
            )}



        </Flex>
    )

}

export default InvoiceDetailSection